// src/config/assistantConfig.js

/**
 * Centralized assistant configuration
 * Change the assistant name in one place to update it throughout the application
 * 
 * Usage:
 *   import { ASSISTANT_NAME, getGreetingMessage, getChatStorageKey } from './config/assistantConfig';
 *   const message = getGreetingMessage(userName);
 */

// ======================
// ASSISTANT CONFIGURATION
// ======================

/**
 * The name of the AI shopping assistant
 * Change this value to update the assistant name throughout the app
 */
export const ASSISTANT_NAME = 'Orbiee';

/**
 * Lowercase version of the assistant name (for localStorage keys, etc.)
 */
export const ASSISTANT_NAME_LOWER = ASSISTANT_NAME.toLowerCase();

/**
 * Get the greeting message for signed-in users
 * @param {string} firstName - User's first name
 * @returns {string} Greeting message
 */
export const getGreetingMessage = (firstName) => {
  if (firstName) {
    return `Hi ${firstName}, I'm ${ASSISTANT_NAME}. How can I help you today?`;
  }
  return `Hi, I'm ${ASSISTANT_NAME}, please sign-in to continue.`;
};

/**
 * Get the greeting message for sign-in modal
 * @param {string} name - User's name
 * @returns {string} Greeting message
 */
export const getSignInGreeting = (name) => {
  return `Hi ${name}, ${ASSISTANT_NAME} here! How can I help you with your shopping today?`;
};

/**
 * Get the localStorage key for chat state
 * @param {string|null} customerId - Customer ID (null for guest)
 * @returns {string} localStorage key
 */
export const getChatStorageKey = (customerId) => {
  return customerId 
    ? `${ASSISTANT_NAME_LOWER}_chat_state_v2_user_${customerId}` 
    : `${ASSISTANT_NAME_LOWER}_chat_state_v2_guest`;
};

// ======================
// EXPORTS
// ======================

export default {
  ASSISTANT_NAME,
  ASSISTANT_NAME_LOWER,
  getGreetingMessage,
  getSignInGreeting,
  getChatStorageKey,
};

